import React, { ReactNode } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@distribute/frontend/utils';

const actionTagVariants = cva(
  'inline-flex items-center justify-center focus-visible:outline-none disabled:cursor-not-allowed font-medium gap-x-1',
  {
    variants: {
      variant: {
        primary:
          'bg-base-white text-gray-700 border border-gray-300 hover:bg-gray-100 hover:border-gray-400',
        'primary-active': 'bg-gray-200 text-gray-900 border border-gray-400',
      },
      size: {
        md: 'h-9 px-4 text-sm rounded-full',
      },
    },
  }
);

export interface ActionTagProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof actionTagVariants> {
  children: ReactNode;
}

export const ActionTag = React.forwardRef<HTMLButtonElement, ActionTagProps>(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(actionTagVariants({ variant, size, className }))}
        {...props}
      >
        {children}
      </button>
    );
  }
);

ActionTag.displayName = 'ActionTag';
